module.exports = {
	"genre": {
		"genre-id-1": "その他",
		"genre-id-2": "ブルース / カントリー / フォーク",
		"genre-id-3": "ブルース",
		"genre-id-4": "カントリー",
		"genre-id-5": "フォーク",
		"genre-id-6": "フランス音楽",
		"genre-id-7": "フランス音楽解説者",
		"genre-id-8": "レトロなフランス音楽",
		"genre-id-9": "フレンチロック",
		"genre-id-10": "クラシック",
		"genre-id-11": "エレクトロニックまたはコンクレート",
		"genre-id-12": "ミュージックコンクレート",
		"genre-id-13": "エレクトロニック音楽",
		"genre-id-14": "ミニマル音楽",
		"genre-id-15": "メロディーとリート",
		"genre-id-16": "リート（ドイツ）",
		"genre-id-17": "リート",
		"genre-id-18": "メロディー",
		"genre-id-19": "メロディー（イギリス）",
		"genre-id-20": "メロディー（北ヨーロッパ）",
		"genre-id-21": "メロディー（フランス）",
		"genre-id-22": "協奏曲",
		"genre-id-23": "その他の楽器",
		"genre-id-24": "鍵盤楽器協奏曲",
		"genre-id-25": "ヴァイオリン協奏曲",
		"genre-id-26": "チェロ協奏曲",
		"genre-id-27": "室内楽",
		"genre-id-28": "その他の構成",
		"genre-id-29": "その他のソロ楽器",
		"genre-id-30": "ピアノソロ",
		"genre-id-31": "カルテット",
		"genre-id-32": "クインテット",
		"genre-id-33": "デュオ",
		"genre-id-34": "トリオ",
		"genre-id-35": "ヴァイオリンソロ",
		"genre-id-36": "チェロソロ",
		"genre-id-37": "交響楽",
		"genre-id-38": "バレエ",
		"genre-id-39": "演劇音楽",
		"genre-id-40": "映画音楽",
		"genre-id-41": "序曲",
		"genre-id-42": "交響詩",
		"genre-id-43": "交響曲",
		"genre-id-44": "歌曲（世俗音楽と宗教音楽）",
		"genre-id-45": "カンタータ (世俗)",
		"genre-id-46": "合唱曲（合唱団）",
		"genre-id-47": "ボーカルアンサンブルによる音楽",
		"genre-id-48": "世俗的オラトリオ",
		"genre-id-49": "ボーカルリサイタル",
		"genre-id-50": "聖歌曲",
		"genre-id-51": "聖なるカンタータ",
		"genre-id-52": "聖なる合唱団",
		"genre-id-53": "ミサ曲、受難曲、レクイエム",
		"genre-id-54": "聖なるオラトリオ",
		"genre-id-55": "オペラ",
		"genre-id-56": "オペラ抜粋",
		"genre-id-57": "フルオペラ",
		"genre-id-58": "オペレッタ",
		"genre-id-59": "コメディー / その他",
		"genre-id-60": "教育用",
		"genre-id-61": "歴史的資料",
		"genre-id-62": "ユーモア",
		"genre-id-63": "文学",
		"genre-id-64": "エレクトロニック",
		"genre-id-65": "アンビエント",
		"genre-id-66": "ダウンテンポ",
		"genre-id-67": "ドラムンベース",
		"genre-id-68": "ハウス",
		"genre-id-69": "ラウンジ音楽",
		"genre-id-70": "テクノ",
		"genre-id-71": "トランス",
		"genre-id-72": "トリップホップ",
		"genre-id-73": "子供用アンビエント",
		"genre-id-74": "アコーディオン",
		"genre-id-75": "童話と童謡",
		"genre-id-76": "教育用",
		"genre-id-77": "カラオケ",
		"genre-id-78": "軍楽隊音楽",
		"genre-id-79": "リラックス",
		"genre-id-80": "ジャズ",
		"genre-id-81": "ビバップ",
		"genre-id-82": "クールジャズ",
		"genre-id-83": "フリージャズ＆アバンギャルド",
		"genre-id-84": "ゴスペル",
		"genre-id-85": "コンテンポラリージャズ",
		"genre-id-86": "ジャズフュージョン＆ジャズロック",
		"genre-id-87": "ジプシージャズ",
		"genre-id-88": "トラッドジャズ&ニューオリンズ",
		"genre-id-89": "ボーカルジャズ",
		"genre-id-90": "ラテンジャズ",
		"genre-id-91": "サウンドトラック",
		"genre-id-92": "映画サウンドトラック",
		"genre-id-93": "ミュージカル",
		"genre-id-94": "ワールド",
		"genre-id-95": "アフリカ音楽",
		"genre-id-96": "アフロビート",
		"genre-id-97": "アジア音楽",
		"genre-id-98": "ブラジル",
		"genre-id-99": "ケルト音楽",
		"genre-id-100": "東ヨーロッパ音楽",
		"genre-id-101": "ファド",
		"genre-id-102": "フラメンコ",
		"genre-id-103": "民族音楽",
		"genre-id-104": "インド音楽",
		"genre-id-105": "東洋音楽",
		"genre-id-106": "ライ",
		"genre-id-107": "サルサ",
		"genre-id-108": "タンゴ",
		"genre-id-109": "ワールドミュージック",
		"genre-id-110": "イディッシュ&クレズマー",
		"genre-id-111": "ズーク&アンティル",
		"genre-id-112": "ポップス / ロック",
		"genre-id-113": "オルタナティヴ&インディー",
		"genre-id-114": "クルーナー",
		"genre-id-115": "ハードロック",
		"genre-id-116": "メタル",
		"genre-id-117": "ポップス",
		"genre-id-118": "パンク - ニューウェイブ",
		"genre-id-119": "ロック",
		"genre-id-120": "プログレッシブロック",
		"genre-id-121": "ロカビリー",
		"genre-id-122": "インターナショナルポップ",
		"genre-id-123": "レゲエ",
		"genre-id-124": "ダンスホール",
		"genre-id-125": "ダブ",
		"genre-id-126": "スカ&ロックステディ",
		"genre-id-127": "ソウル / ファンク / R&B",
		"genre-id-128": "アシッドジャズ",
		"genre-id-129": "ダンス",
		"genre-id-130": "ディスコ",
		"genre-id-131": "ファンク",
		"genre-id-132": "R&B",
		"genre-id-133": "ヒップホップ",
		"genre-id-134": "ソウル",
		"genre-id-135": "オペレッタ",
		"genre-id-137": "トランペット協奏曲",
		"genre-id-138": "管楽器協奏曲",
		"genre-id-139": "クロスオーバー",
		"genre-id-140": "ドキュメント",
		"genre-id-141": "ニューエイジ",
		"genre-id-142": "アンビエント",
		"genre-id-144": "クロスオーバー",
		"genre-id-145": "ディキシーランド",
		"genre-id-146": "ラグタイム",
		"genre-id-147": "テレビシリーズ",
		"genre-id-148": "テレビゲーム",
		"genre-id-149": "ラテン",
		"genre-id-150": "北米音楽",
		"genre-id-151": "ヨーロッパ音楽",
		"genre-id-152": "ジプシー",
		"genre-id-153": "伝統音楽",
		"genre-id-154": "マグリブ音楽",
		"genre-id-155": "ロシア音楽",
		"genre-id-156": "トルコ音楽",
		"genre-id-157": "インディーポップ",
		"genre-id-158": "春歌",
		"genre-id-159": "クリスマス音楽",
		"genre-id-160": "ドイツ音楽",
		"genre-id-161": "スコットランド音楽",
		"genre-id-162": "スペイン音楽",
		"genre-id-163": "ギリシャ音楽",
		"genre-id-164": "アイルランド音楽",
		"genre-id-165": "イタリア音楽",
		"genre-id-166": "ポルトガル音楽",
		"genre-id-167": "子供向け",
		"genre-id-176": "世俗的な歌曲",
		"genre-id-173": "シュラーガー",
		"genre-id-171": "ムード音楽",
		"genre-id-172": "民俗音楽",
		"genre-id-174": "アイリッシュケルト音楽",
		"genre-id-175": "アイリッシュポップ音楽",
		"genre-id-168": "スイスの民族音楽",
		"genre-id-178": "ドイツ語",
		"genre-id-177": "英語",
		"genre-id-170": "フランス語",
		"genre-id-179": "オランダ語",
		"genre-id-180": "ボレロ",
		"genre-id-181": "ラテン現代",
		"genre-id-182": "レゲトン",
		"genre-id-183": "MPB",
		"genre-id-184": "ボサノヴァ",
		"genre-id-185": "サンバ",
		"genre-id-186": "フォホー",
		"genre-id-187": "パゴージ",
		"genre-id-188": "ブラジルファンク",
		"genre-id-189": "セルタネージャ",
		"genre-id-190": "邦楽 / J-POP",
		"genre-id-191": "J-POP",
		"genre-id-192": "日本伝統音楽",
		"genre-id-193": "韓国音楽 / K-POP",
		"genre-id-194": "K-POP",
		"genre-id-195": "韓国伝統音楽",
		"genre-id-196": "アニメ/ ゲーム",
		"genre-id-197": "アニメ"
	},
	"article-cat": {
		"article-cat-2": "-- 一般アーカイブ --",
		"article-cat-4": "インタビュー",
		"article-cat-5": "-- 一般アーカイブ --",
		"article-cat-7": "オンステージ",
		"article-cat-8": "ノミネートと受賞",
		"article-cat-10": "メディア",
		"article-cat-22": "Dear Missing",
		"article-cat-51": "ディスコグラフィ",
		"article-cat-53": "参考文献",
		"article-cat-54": "ポートレイト",
		"article-cat-97": "ニュース",
		"article-cat-98": "最新トピック",
		"article-cat-100": "業界",
		"article-cat-101": "ニューリリース",
		"article-cat-117": "ジャズ ニュース",
		"article-cat-122": "ニュース",
		"article-cat-189": "インタビュー",
		"article-cat-197": "聴き比べ",
		"article-cat-199": "インタビュー",
		"article-cat-209": "記憶が薄れつつある",
		"article-cat-226": "洞窟カネム",
		"article-cat-227": "フォルティッシモ",
		"article-cat-229": "できますか?",
		"article-cat-238": "マガジン = レビュー",
		"article-cat-252": "カラッソセラピー",
		"article-cat-260": "シンフォマン",
		"article-cat-267": "クロスロード",
		"article-cat-279": "コンサート",
		"article-cat-286": "機密",
		"article-cat-287": "アジェンダ",
		"article-cat-293": "イベント",
		"article-cat-295": "コンサートとツアー",
		"article-cat-297": "Hi-Fi",
		"article-cat-298": "検証",
		"article-cat-299": "実用的",
		"article-cat-301": "ニュース",
		"article-cat-302": "卓越したサウンドレコーディング",
		"article-cat-303": "サウンドウィザード",
		"article-cat-304": "Trax",
		"article-cat-305": "Old wax in clean ears",
		"article-cat-306": "Voxpop",
		"article-cat-311": "ベルリン・フィルハーモニー管弦楽団",
		"article-cat-312": "アンドレ・チュブフ : 記憶と風景",
		"article-cat-315": "フランソワ・ウドリ : 一粒の塩",
		"article-cat-316": "Qobuzクラシック",
		"article-cat-318": "論説",
		"article-cat-319": "Qobuz at",
		"article-cat-320": "マルセイユ",
		"article-cat-321": "パリバロックフェスティバル",
		"article-cat-322": "Hi-Fiマニア",
		"article-cat-323": "レンヌ",
		"article-cat-324": "論説",
		"article-cat-325": "Qobuz",
		"article-cat-326": "ジャン・ミシェル・プルーストの論説",
		"article-cat-327": "ジャン・ミシェル・プルースト = 今月のニュース",
		"article-cat-328": "Qobuz Monday",
		"article-cat-329": "リール",
		"article-cat-330": "はい、達人たち!",
		"article-cat-331": "Qobuzミニッツ",
		"article-cat-332": "現代",
		"article-cat-333": "ニュースレター",
		"article-cat-334": "Qobuzウィークリーニュースレター",
		"article-cat-335": "プロモーションニュースレター",
		"article-cat-336": "Qobuz Hi-Fiニュースレター",
		"article-cat-337": "クラシックニュースレター",
		"article-cat-339": "エレクトロニックニュースレター",
		"article-cat-340": "子供用ニュースレター",
		"article-cat-341": "ユーモア / スポークンワードニュースレター",
		"article-cat-342": "HDオーディオ対応のスマートフォン",
		"article-cat-343": "フランス音楽ニュースレター",
		"article-cat-344": "フランス音楽",
		"article-cat-345": "モダンスタイル",
		"article-cat-347": "アンビエントニュースレター",
		"article-cat-350": "英語",
		"article-cat-351": "ドイツ語",
		"article-cat-352": "オランダ語",
		"article-cat-353": "英語",
		"article-cat-354": "ドイツ語",
		"article-cat-355": "オランダ語",
		"article-cat-356": "オランダ語",
		"article-cat-357": "ドイツ語",
		"article-cat-358": "英語",
		"article-cat-359": "Old Sequins and Old Breastplates",
		"article-cat-360": "Hannah Krooz",
		"article-cat-361": "チュートリアル",
		"article-cat-362": "クラシックニューリリース",
		"article-cat-363": "Qobuzスタジオ",
		"article-cat-364": "Qobuzスタジオ",
		"article-cat-365": "トップストーリー",
		"article-cat-368": "アーカイブ",
		"article-cat-369": "Qobuzシェフ",
		"article-cat-370": "One Cover / One Word"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/apiLocale/apiJa.json
// module id = 561
// module chunks = 0